// extracted by mini-css-extract-plugin
module.exports = {"bodylayout":"Body_bodylayout__hM5QL","section":"Body_section__2WEmg","accordianDescription":"Body_accordianDescription__3K9cC"};